import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_DASHBOARDS](state, data) {
    console.log('mutation ', data)
    state.allDashboards = data
  },
}
